module.exports = __webpack_public_path__ + "assets/images/02-active_a35a5f5565fc0c4220a34c9f8483a2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-2/02-active.png
// module id = 235
// module chunks = 0